import React from 'react';

import '../icon-component.scss';

/**
 * Custom Exclamation Icon in SVG - can be filled with a custom class
 */

const ExclamationComponent = () => (
  <svg className="icon-component" viewBox="0 0 2 11">
    <g stroke="none" fill="none">
      <path d="M1,0.25 L1,6.25" />
      <circle cx="1" cy="9.25" r="1" />
    </g>
  </svg>
);

ExclamationComponent.displayName = 'ExclamationIcon';

export default ExclamationComponent;
